<mobi-content-section
  ngSkipHydration
  [id]="paragraph().anchorLinkUrl ? paragraph().anchorLinkUrl : paragraph().id"
  [content]="content"
  [width]="width()"
  class="mobi-iframe-resizer"
  [mobiTracking]="paragraph()"
>
  <ng-template #content>
    @if (paragraph().title) {
      <mobi-heading-select
        class="block"
        [title]="paragraph().title ?? ''"
        [headingType]="paragraph().titleSize"
        [headingStyle]="paragraph().titleSize"
      />
    }
    <div [innerHTML]="sanitized()" #iframeWrapper mobiRunScripts></div>
  </ng-template>
</mobi-content-section>
